$(document).ready(function () {
  const btnContainer = $("#prime-product-add-to-cart-btns");
  const QuantityDom = btnContainer.find("input");
  btnContainer.find(".item-dec").click(function () {
    quantity = Number(QuantityDom.val());
    QuantityDom.val(quantity - 1);
    if (quantity == 2) $(this).attr("disabled", true);
    btnContainer.find(".item-inc").removeAttr("disabled");
  });
  btnContainer.find(".item-inc").click(function () {
    quantity = Number(QuantityDom.val());
    QuantityDom.val(quantity + 1);
    if (quantity == 99) $(this).attr("disabled", true);
    btnContainer.find(".item-dec").removeAttr("disabled");
  });

  btnContainer.find(".add-to-cart").click(async function () {
    const Btn = $(this);
    Btn.attr("disabled", true).text("Adding...");
    await addToCart(
      $(this).attr("data-product-id"),
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      Number(QuantityDom.val())
    );
    Btn.text("Thank you");
    Btn.removeAttr("disabled")
    setTimeout(() => {
      Btn.text("Add TO Cart");
    }, 1500);
  });

  new Swiper(".prime-image-text-swiper", {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  $(".prime-image-btn").click(function() {
    window.scrollTo({top: 850, behavior:'smooth'});
  })

});
